var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneMobile = function SvgPhoneMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 16,
      height: 17,
      viewBox: "0 0 16 17",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.6003 13.8334C6.67428 13.8334 2.66695 9.82537 2.66695 4.90004C2.66695 3.94404 3.44428 3.16671 4.40028 3.16671C4.47295 3.16671 4.54495 3.17137 4.61828 3.18071L5.32562 6.26137C5.23824 6.30683 5.14475 6.35573 5.05353 6.40343L5.05316 6.40363L4.96695 6.44871C4.39228 6.74871 3.93895 6.98604 4.17695 7.50937C4.96095 9.74004 6.76028 11.54 8.96428 12.3134C9.52581 12.5384 9.7437 12.1217 10.045 11.5457L10.049 11.538C10.0835 11.4727 10.119 11.4045 10.1542 11.3369L10.1545 11.3363C10.1831 11.2814 10.2115 11.2269 10.239 11.1747L13.319 11.8814C13.329 11.9534 13.3336 12.026 13.3336 12.1C13.3336 13.056 12.5563 13.8334 11.6003 13.8334ZM14.501 11.1054C14.4256 10.8887 14.2443 10.726 14.0203 10.6747L10.0443 9.76204C9.82495 9.71271 9.59562 9.77471 9.43362 9.93071C9.33828 10.0214 9.33628 10.024 8.90295 10.8514C7.48295 10.2047 6.31962 9.04537 5.65028 7.59604C6.47628 7.16337 6.47828 7.16137 6.56962 7.06671C6.72562 6.90404 6.78828 6.67471 6.73828 6.45604L5.82562 2.48004C5.77428 2.25604 5.61095 2.07404 5.39428 1.99871C5.23562 1.94404 5.07228 1.90271 4.91095 1.87671C4.74495 1.84804 4.57362 1.83337 4.40028 1.83337C2.70895 1.83337 1.33362 3.20871 1.33362 4.90004C1.33362 10.5614 5.93895 15.1667 11.6003 15.1667C13.291 15.1667 14.667 13.7914 14.667 12.1C14.667 11.928 14.6516 11.758 14.6236 11.5927C14.597 11.426 14.5556 11.2627 14.501 11.1054ZM8.66668 5.83337C9.76935 5.83337 10.6667 6.73071 10.6667 7.83337C10.6667 8.20204 10.9647 8.50004 11.3334 8.50004C11.702 8.50004 12 8.20204 12 7.83337C12 5.99537 10.5047 4.50004 8.66668 4.50004C8.29868 4.50004 8.00002 4.79804 8.00002 5.16671C8.00002 5.53537 8.29868 5.83337 8.66668 5.83337ZM13.3334 7.83337C13.3334 5.26071 11.2394 3.16671 8.66668 3.16671C8.29868 3.16671 8.00002 2.86871 8.00002 2.50004C8.00002 2.13137 8.29868 1.83337 8.66668 1.83337C11.9754 1.83337 14.6667 4.52471 14.6667 7.83337C14.6667 8.20204 14.3687 8.50004 14 8.50004C13.6314 8.50004 13.3334 8.20204 13.3334 7.83337Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgPhoneMobile, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/phone-mobile.d3c0ea7f.svg";
export { ForwardRef as ReactComponent };